<template>
  <div class="model_instance">
    <div class="model_instance__header">
      <h4 class="title">
        {{ translate("server.add_instance") }}
      </h4>
    </div>

    <div class="model_instance__body">
      <div class="instance">
        <div class="row">
          <div class="col-md-12">
            <fg-input
                v-model="new_instance.name"
                type="text"
                :label="translate('server.table_instance.name')"
                :placeholder="translate('server.table_instance.name')"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input
                v-model="new_instance.port"
                @input.native="limit_port"
                type="number"
                :min="1"
                :max="65535"
                :label="translate('server.table_instance.port')"
                :placeholder="translate('server.table_instance.port')"
            />
          </div>

          <div class="col-md-8">
            <div class="form_select">
              <label> {{ translate("server.table_instance.group_name") }} </label>
              <tree-select
                  :options="server_instance_group_list"
                  :multiple="false"
                  v-model="new_instance.server_instance_group_id"
                  :placeholder="translate('server.table_instance.group_name')"
                  :clearable="false"
              />
            </div>
          </div>
        </div>

        <div class="line">
          <div class="input_wrap">
            <fg-input
                v-model="new_instance.iperf_settings"
                type="text"
                :label="translate('server.table_instance.iperf_settings')"
                :placeholder="translate('server.table_instance.iperf_settings')"
            />
          </div>
        </div>

        <div class="line text_wrap">
          <div class="input_wrap form-group">
            <label>{{ translate('server.table_instance.description') }}</label>
            <textarea
                v-model="new_instance.descr"
                class="input_text"
                name="equipment"
                rows="10"
            />
          </div>
        </div>

      </div>
    </div>
    <div class="model_instance__footer">
      <span
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="save_instance"
      >
        {{ translate('btn.edit') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>

export default {
  name: 'AddInstance',
  props:{
    server_id:{
      type: Number,
      required: true,
    },
    server_instance_groups:{
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      new_instance: {
        name: null,
        port: null,
        iperf_settings: null,
        descr: null,
        server_instance_group_id: null
      }
    }
  },

  computed: {
    server_instance_group_list(){
      return this.server_instance_groups.map(item =>{
        return { id: item.id, label: item.name };
      })
    }
  },

  methods: {
    limit_port(event){
      if (Number(event.target.value) > 65535) {
        event.target.value = 65535
        this.new_instance.port = 65535
      }
    },
    save_instance(){
      let new_instance = {...this.new_instance}
      new_instance.port = Number(new_instance.port)
      if (!Number.isInteger(new_instance.port) || new_instance.port < 1 || new_instance.port > 65535) {
        this.global_notify('danger', this.translate('server.table_instance.invalid_port'))
        return
      }
      new_instance.server_id = this.server_id
      this.$http.v1.addServerInstance(new_instance, () => {
        this.global_notify('info', this.translate('server.table_instance.saved_instance_success'))
        this.$emit("update")
      })
    },
    update(){
      this.$emit('update')
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .model_instance{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      //height: 100%;
      //height: 600px;
      .instance{
        width: 100%;
        height: 100%;
        .line{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .input_wrap{
            width: 100%;
            text-align: start;
            margin-bottom: 10px;
          }
        }
        .row{
          .form-group,
          .form_select .vue-treeselect{
            margin-bottom: 5px;
          }

        }
      }

    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }


</style>
